<template>
  <custom-fields-setting-component
    :itemType="itemType"
    :preloadedItem="preloadedItem">

    <template :slot="'body'">
      <v-form v-model='valid'>
        <v-row>
          <setting-field-row
            :cols='12'
            :name='"Field Name *"'
            :description='"The field name property sets the name of your custom field. This also an input label."'
            :placeholder='"Enter Field Name ..."'
            :fieldType='"text"'
            v-model='preloadedItem.name'
            isName
            @inputEvent='(newVal) => { preloadedItem.name = newVal }'/>

          <setting-field-row
            :cols='12'
            :name='"Placeholder text"'
            :description='"The Placeholder attribute specified a short hint that describes the expected value of an input field (e.g. a sample value or a short description of the expected format)"'
            :placeholder='"Enter Placeholder Text(optional) ..."'
            :fieldType='"text"'
            v-model='preloadedItem.placeholder'
            @inputEvent='(newVal) => { preloadedItem.placeholder = newVal }'/>

          <payAttention v-if='isEdit' />
          <v-col cols='12'>
            <div>
              <img :class="[$style['image-icon'], 'left']" src="@/assets/icons/svg/pencil2.svg"/>
              <span :class="$style['label-text']">Default options</span>
            </div>
            <div class='mt-2 input-box'>
              <v-icon class="mr-1" style="color: #7d7d7d" size='20'>
                mdi-help-circle
              </v-icon>
              <span style="color: #7d7d7d">Add dropdown options to show in value selection</span>
            </div>
            <div class='mt-2 input-box'>

              <div v-if='preloadedItem.customFieldArrayValues.length'>
                <div class="mt-2" v-for='(arrayValue, index) in preloadedItem.customFieldArrayValues' :key='index'>
                  <div class="inputBox">
                    <v-text-field
                      dense
                      v-model="arrayValue.value"
                      color="#43425d"
                      maxlength="128"
                      class="r-field item-name-field"
                      ref="textField"
                      :rules="nameRules"/>

                    <div class="controls-placement">
                      <span class="setDefaultBtn" @click="setDefaultItem(index)">
                        {{  arrayValue.isAsDefault ? 'Unset As Default' : 'Set As Default' }}
                      </span>

                      <v-btn
                        @click="deleteValue(index)"
                        depressed
                        class="px-1"
                        color="transparent"
                        min-width="0">
                        <v-icon color="#7671bd">mdi-close</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </div>
              </div>

              <span @click='addNewCustomFieldArrayValue' class="cursor-pointer">
                <v-icon class='mr-1'>mdi-plus</v-icon>
                Add Options
              </span>
            </div>
          </v-col>
          <v-col cols='12'>
            <div>
              <img :class="[$style['image-icon'], 'left']" src="@/assets/icons/svg/checkbox.svg"/>
              <span :class="$style['label-text']">Applicable to</span>
            </div>
            <div class='mt-2 input-box'>
              <v-icon class="mr-1" style="color: #7d7d7d" size='20'>
                mdi-help-circle
              </v-icon>
              <span style="color: #7d7d7d">
                Choose whether to apply the field to all elements or add the field to individual elements
              </span>
            </div>
            <div class='mt-2 input-box'>
              <v-checkbox
                v-model="applicableToAll"
                :label="applicableToCheckboxText"
                color="#8074c2"
                class='mt-1'/>
            </div>
          </v-col>
          <v-col>
            <div class="text-left pt-10">
              <v-btn @click="cancel" depressed class="cancel-btn">
                Cancel
              </v-btn>
              <v-btn @click="save" depressed :disabled="!valid" class="save-item-btn save-btn">
                Save
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </template>
  </custom-fields-setting-component>
</template>

<script>
import customFieldsSettingComponent from '@/components/customFields/customFieldsSettingComponent'
import settingFieldRow from '@/components/customFields/commonMixins/settingFieldRow'
import { saveNewItemMixin } from '@/components/customFields/commonMixins/_helpers/saveNewItem.mixin.js'
import { cancelNewItemMixin } from '@/components/customFields/commonMixins/_helpers/cancelNewItem.mixin.js'
import { applicableToCheckboxTextMixin } from '@/components/customFields/commonMixins/_helpers/applicableToCheckboxText.mixin.js'
import { settingViewBaseMixin } from '@/components/customFields/commonMixins/_helpers/settingViewBase.mixin.js'

export default {
  mixins: [saveNewItemMixin, cancelNewItemMixin, applicableToCheckboxTextMixin, settingViewBaseMixin],
  components: {
    customFieldsSettingComponent,
    settingFieldRow
  },
  data: function() {
    return {
      itemType: 'dropDown',
      applicableToAll: this.preloadedItem.applicableToAll || false,
      iterator: 0,
      valid: true
    }
  },
  watch: {
    'preloadedItem.customFieldArrayValues': {
      handler (arrayValues) {
        this.valid = (arrayValues.length && !arrayValues.find(item => !item.value.length))
      },
      deep: true
    }
  },
  methods: {
    deleteValue(index) {
      if (this.preloadedItem.customFieldArrayValues.isAsDefault) {
        this.preloadedItem.defaultValue = null
      }
      this.preloadedItem.customFieldArrayValues.splice(index, 1)
      this.$emit('changeItemProperty', 'customFieldArrayValues', this.preloadedItem.customFieldArrayValues)
    },
    addNewCustomFieldArrayValue() {
      this.preloadedItem.customFieldArrayValues.push({
        value: '',
        isAsDefault: false
      })
    },
    setDefaultItem(index) {
      const arr = this.preloadedItem.customFieldArrayValues.map((cfav, i) => {
        cfav.isAsDefault = (i === index)
        return cfav
      })
      this.preloadedItem.customFieldArrayValues = arr
    }
  }
}
</script>

<style lang='scss'>
.inputBox {
  position: relative;
  padding-top: 14px;
  .controls-placement {
    position: absolute;
    bottom: 0;
    right: 0;
    height: 25px;
    top: 10px;
  }
  .setDefaultBtn {
    cursor: pointer;
    user-select: none;
    transition: 0.2s linear;
    color: #7671bd;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      width: 0px;
      height: 1px;
      bottom: -1px;
      left: 50%;
      transform: translateX(-50%);
      transition: 0.2s linear;
      background-color: darken(#7671bd, 10%);
    }
    &:hover {
      color: darken(#7671bd, 10%);
      &::before {
        width: 100%;
      }
    }
  }
}
</style>

<style lang='scss' module src='../commonStyles/index.module.scss'>
.cursor-pointer {
  &:hover {
    color: #8074c2;
  }
}
</style>
